import React from 'react';
import { useTranslation } from "react-i18next";

function OfficialSiteButton(props) {
	const { t } = useTranslation();
	return (
		<>
			<a className="official-site-link" href="/guide">{t("menu.guide")}</a>
			{props.officialUrl && (
				<a className="guide-link" href={props.officialUrl} target="_blank" rel="noreferrer">{t("menu.officialSite")}</a>
			)}

			<ul className="header-social">
				{props.facebookUrl && (
					<li className="header-social__item header-social__item--facebook"><a href={props.facebookUrl} target="_blank" rel="noreferrer" /></li>
				)}
				{props.twitterUrl && (
					<li className="header-social__item header-social__item--twitter"><a href={props.twitterUrl}  target="_blank" rel="noreferrer" /></li>
				)}
				{/* */}
				<li className="header-social__item header-social__item--instagram">
					<a href="https://www.instagram.com/springfestivalintokyo/" title="Instagram" target="_blank" rel="noreferrer"></a>
				</li>
				<li className="header-social__item header-social__item--youtube">
					<a href="https://www.youtube.com/user/tokyoHARUSAI" title="YouTube" target="_blank" rel="noreferrer"></a>
				</li>
				{/* */}
			</ul>
		</>
	);
}

export default OfficialSiteButton;
